import { PayloadAction, createSlice } from "@reduxjs/toolkit";
//constants
import {
  LAYOUT_TYPES,
  LAYOUT_SEMI_DARK,
  LAYOUT_SKIN,
  LAYOUT_MODE_TYPES,
  LAYOUT_DIRECTION,
  LAYOUT_CONTENT_WIDTH,
  LEFT_SIDEBAR_SIZE_TYPES,
  LEFT_NAVIGATION_TYPES,
  LEFT_SIDEBAR_COLOR_TYPES,
  LAYOUT_TOPBAR_THEME_TYPES,
  LAYOUT_NON_AUTH_THEME_TYPES
} from "common/constants/layout";
import { RootState } from "slices/store";
import { Branding } from '../../models/settings/branding'
export interface LayoutState {
  branding?: Branding;
  layoutType: LAYOUT_TYPES.HORIZONTAL | LAYOUT_TYPES.VERTICAL;
  layoutSemiDarkType: LAYOUT_SEMI_DARK.LIGHT | LAYOUT_SEMI_DARK.DARK;
  layoutSkintype: LAYOUT_SKIN.DEFAULT | LAYOUT_SKIN.BORDERED;
  layoutModeType: LAYOUT_MODE_TYPES.LIGHTMODE | LAYOUT_MODE_TYPES.DARKMODE;
  layoutDirectionType: LAYOUT_DIRECTION.LTR | LAYOUT_DIRECTION.RTL;
  layoutContentWidthType: LAYOUT_CONTENT_WIDTH.FLUID | LAYOUT_CONTENT_WIDTH.BOXED;
  layoutSidebarSizeType: LEFT_SIDEBAR_SIZE_TYPES.DEFAULT | LEFT_SIDEBAR_SIZE_TYPES.COMPACT | LEFT_SIDEBAR_SIZE_TYPES.SMALLICON;
  layoutNavigationType: LEFT_NAVIGATION_TYPES.STICKY | LEFT_NAVIGATION_TYPES.SCROLL | LEFT_NAVIGATION_TYPES.BORDERED | LEFT_NAVIGATION_TYPES.HIDDEN;
  layoutSidebarColorType: LEFT_SIDEBAR_COLOR_TYPES.LIGHT | LEFT_SIDEBAR_COLOR_TYPES.DARK | LEFT_SIDEBAR_COLOR_TYPES.BRAND | LEFT_SIDEBAR_COLOR_TYPES.MODERN;
  layoutTopbarColorType: LAYOUT_TOPBAR_THEME_TYPES.LIGHT | LAYOUT_TOPBAR_THEME_TYPES.DARK | LAYOUT_TOPBAR_THEME_TYPES.BRAND;
  layoutNoneAuthTheme: LAYOUT_NON_AUTH_THEME_TYPES.BASIC | LAYOUT_NON_AUTH_THEME_TYPES.BOXED | LAYOUT_NON_AUTH_THEME_TYPES.COVER | LAYOUT_NON_AUTH_THEME_TYPES.MODERN;
}

export const initialState: LayoutState = {
  layoutType: LAYOUT_TYPES.VERTICAL,
  layoutSemiDarkType: LAYOUT_SEMI_DARK.DARK,
  layoutSkintype: LAYOUT_SKIN.DEFAULT,
  layoutModeType: LAYOUT_MODE_TYPES.LIGHTMODE,
  layoutDirectionType: LAYOUT_DIRECTION.LTR,
  layoutContentWidthType: LAYOUT_CONTENT_WIDTH.FLUID,
  layoutSidebarSizeType: LEFT_SIDEBAR_SIZE_TYPES.DEFAULT,
  layoutNavigationType: LEFT_NAVIGATION_TYPES.STICKY,
  layoutSidebarColorType: LEFT_SIDEBAR_COLOR_TYPES.DARK,
  layoutTopbarColorType: LAYOUT_TOPBAR_THEME_TYPES.DARK,
  layoutNoneAuthTheme: LAYOUT_NON_AUTH_THEME_TYPES.BASIC
};

const LayoutSlice = createSlice({
  name: 'LayoutSlice',
  initialState,
  reducers: {
    setBrandingDataAction(state: LayoutState, action: PayloadAction<Branding>) {
      state.branding = action.payload;
    },
    changeLayoutAction(state: LayoutState, action: PayloadAction<LAYOUT_TYPES>) {
      state.layoutType = action.payload;
    },
    changeLayoutSemiDarkAction(state: LayoutState, action: PayloadAction<LAYOUT_SEMI_DARK>) {
      state.layoutSemiDarkType = action.payload;
    },
    changeSkinAction(state: LayoutState, action: PayloadAction<LAYOUT_SKIN>) {
      state.layoutSkintype = action.payload;
    },
    changeLayoutModeAction(state: LayoutState, action: PayloadAction<LAYOUT_MODE_TYPES>) {
      state.layoutModeType = action.payload;
    },
    changeDirectionAction(state: LayoutState, action: PayloadAction<LAYOUT_DIRECTION>) {
      state.layoutDirectionType = action.payload;
    },
    changeLayoutContentWidthAction(state: LayoutState, action: PayloadAction<LAYOUT_CONTENT_WIDTH>) {
      state.layoutContentWidthType = action.payload;
    },
    changeLayoutSidebarSizeAction(state: LayoutState, action: PayloadAction<LEFT_SIDEBAR_SIZE_TYPES>) {
      state.layoutSidebarSizeType = action.payload;
    },
    changeNavigationAction(state: LayoutState, action: PayloadAction<LEFT_NAVIGATION_TYPES>) {
      state.layoutNavigationType = action.payload;
    },
    changeLeftSidebarColorTypeAction(state: LayoutState, action: PayloadAction<LEFT_SIDEBAR_COLOR_TYPES>) {
      state.layoutSidebarColorType = action.payload;
    },
    changeLayoutTopbarColorAction(state: LayoutState, action: PayloadAction<LAYOUT_TOPBAR_THEME_TYPES>) {
      state.layoutTopbarColorType = action.payload;
    },
    changeLayoutNoneAuthThemeAction(state: LayoutState, action: PayloadAction<LAYOUT_NON_AUTH_THEME_TYPES>) {
      state.layoutNoneAuthTheme = action.payload;
    }
  }
});

export const {
  changeLayoutAction,
  changeLayoutSemiDarkAction,
  changeSkinAction,
  changeLayoutModeAction,
  changeDirectionAction,
  changeLayoutContentWidthAction,
  changeLayoutSidebarSizeAction,
  changeNavigationAction,
  changeLeftSidebarColorTypeAction,
  changeLayoutTopbarColorAction,
  changeLayoutNoneAuthThemeAction,
  setBrandingDataAction
} = LayoutSlice.actions;

export default LayoutSlice.reducer;

export const getLayoutState = (store: RootState): LayoutState => store.layout;
